export default "__VITE_ASSET__bf58726d__"